// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"534":"babab88f","554":"d9011cc8"}[chunkId] + ".chunk.js";
};